import { API_ENDPOINTS } from "../../../../utils/constants";

// const MAX_CACHE_SIZE = 10000;
// const SAVE_THRESHOLD = 20;
// const CACHE_KEY = "transliterationCache";

// const cache = loadCacheFromLocalStorage();
// let newEntriesCount = 0;

// function loadCacheFromLocalStorage() {
//   const cachedData = localStorage.getItem(CACHE_KEY);
//   return cachedData ? JSON.parse(cachedData) : {};
// }

// function saveCacheToLocalStorage() {
//   localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
// }

// const getWordWithLowestFrequency = (dictionary) => {
//   let lowestFreqWord = null;
//   let lowestFreq = Infinity;

//   for (const word in dictionary) {
//     if (dictionary[word].frequency < lowestFreq) {
//       lowestFreq = dictionary[word].frequency;
//       lowestFreqWord = word;
//     }
//   }

//   return lowestFreqWord;
// };

export const getTransliterateSuggestions = async (word, config) => {
  const { showCurrentWordAsLastSuggestion = true, lang = "hi" } = config || {};

  const TRANSLITRATION_SERVICE_ID = import.meta.env
    .VITE_BHASHINI_TRANSLITRATION_SERVICE_ID;

  // if (!cache[lang]) {
  //   cache[lang] = {};
  // }

  // if (cache[lang][word.toLowerCase()]) {
  //   cache[lang][word.toLowerCase()].frequency += 1;
  //   return cache[lang][word.toLowerCase()].suggestions;
  // }

  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pipelineTasks: [
          {
            taskType: "transliteration",
            config: {
              language: {
                sourceLanguage: "en",
                targetLanguage: lang,
              },
              serviceId: TRANSLITRATION_SERVICE_ID,
              isSentence: false,
              numSuggestions: 4,
            },
          },
        ],
        inputData: {
          input: [
            {
              source: word,
            },
          ],
        },
      }),
    };

    const res = await fetch(API_ENDPOINTS.transliterate, requestOptions);
    const data = await res.json();
    const result = data?.pipelineResponse?.[0]?.output?.[0]?.target || [];

    if (result.length > 0) {
      const found = showCurrentWordAsLastSuggestion
        ? [...result, word]
        : result;

      // if (Object.keys(cache[lang]).length >= MAX_CACHE_SIZE) {
      //   const lowestFreqWord = getWordWithLowestFrequency(cache[lang]);
      //   if (lowestFreqWord) {
      //     delete cache[lang][lowestFreqWord];
      //   }
      // }

      // cache[lang][word.toLowerCase()] = {
      //   suggestions: found,
      //   frequency: 1,
      // };

      // newEntriesCount += 1;
      // if (newEntriesCount >= SAVE_THRESHOLD) {
      //   saveCacheToLocalStorage();
      //   newEntriesCount = 0;
      // }

      return found;
    } else {
      if (showCurrentWordAsLastSuggestion) {
        const fallback = [word];
        return fallback;
      }
      return [];
    }
  } catch (e) {
    console.error("There was an error with transliteration", e);
    return [];
  }
};

// window.addEventListener("beforeunload", saveCacheToLocalStorage);
